import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "groupInputs flex" }
const _hoisted_4 = { class: "inputRow" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow" }
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "inputRow" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = { class: "inputField flex-grow" }
const _hoisted_11 = { class: "groupInputs flex" }
const _hoisted_12 = { class: "inputRow" }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = { class: "inputField flex-grow" }
const _hoisted_15 = { class: "error-msg" }
const _hoisted_16 = { class: "inputRow" }
const _hoisted_17 = { class: "inputTitle" }
const _hoisted_18 = { class: "inputField flex-grow" }
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "inputRow" }
const _hoisted_21 = { class: "inputTitle" }
const _hoisted_22 = { class: "inputField flex-grow" }
const _hoisted_23 = { class: "error-msg" }
const _hoisted_24 = { class: "inputGroup" }
const _hoisted_25 = { class: "groupTitle" }
const _hoisted_26 = { class: "groupInputs flex" }
const _hoisted_27 = { class: "inputRow" }
const _hoisted_28 = { class: "inputTitle" }
const _hoisted_29 = { class: "inputField flex-grow" }
const _hoisted_30 = { class: "error-msg" }
const _hoisted_31 = { class: "inputRow" }
const _hoisted_32 = { class: "inputTitle" }
const _hoisted_33 = { class: "inputField flex-grow" }
const _hoisted_34 = { class: "groupInputs flex" }
const _hoisted_35 = { class: "inputRow" }
const _hoisted_36 = { class: "inputTitle" }
const _hoisted_37 = { class: "inputField flex-grow" }
const _hoisted_38 = { class: "inputRow" }
const _hoisted_39 = { class: "inputTitle" }
const _hoisted_40 = { class: "inputField flex-grow" }
const _hoisted_41 = { class: "groupInputs flex" }
const _hoisted_42 = { class: "inputRow" }
const _hoisted_43 = { class: "inputTitle" }
const _hoisted_44 = { class: "inputField flex-grow" }
const _hoisted_45 = { class: "inputRow" }
const _hoisted_46 = { class: "inputTitle" }
const _hoisted_47 = { class: "inputField flex-grow" }
const _hoisted_48 = { class: "groupInputs flex" }
const _hoisted_49 = { class: "inputRow" }
const _hoisted_50 = { class: "inputTitle" }
const _hoisted_51 = { class: "inputField flex-grow" }
const _hoisted_52 = { class: "error-msg" }
const _hoisted_53 = { class: "inputRow" }
const _hoisted_54 = { class: "inputTitle" }
const _hoisted_55 = { class: "inputField flex-grow" }
const _hoisted_56 = { class: "error-msg" }
const _hoisted_57 = { class: "inputGroup" }
const _hoisted_58 = { class: "groupTitle" }
const _hoisted_59 = { class: "groupInputs flex" }
const _hoisted_60 = { class: "inputRow" }
const _hoisted_61 = { class: "inputField flex my-2" }
const _hoisted_62 = { class: "inputTitle ml-2" }
const _hoisted_63 = { for: "phoneNumberAltIsFallback" }
const _hoisted_64 = { class: "inputRow" }
const _hoisted_65 = { class: "inputField flex my-2" }
const _hoisted_66 = { class: "inputTitle ml-2" }
const _hoisted_67 = { for: "couplingEnabled" }
const _hoisted_68 = { class: "groupInputs flex" }
const _hoisted_69 = { class: "inputRow" }
const _hoisted_70 = { class: "inputTitle" }
const _hoisted_71 = { class: "inputField flex-grow" }
const _hoisted_72 = ["placeholder"]
const _hoisted_73 = { class: "error-msg" }
const _hoisted_74 = { class: "inputRow" }
const _hoisted_75 = { class: "inputTitle" }
const _hoisted_76 = { class: "inputField flex-grow" }
const _hoisted_77 = ["placeholder"]
const _hoisted_78 = { class: "error-msg" }
const _hoisted_79 = { class: "groupInputs flex" }
const _hoisted_80 = { class: "inputRow" }
const _hoisted_81 = { class: "inputTitle" }
const _hoisted_82 = { class: "inputField flex-grow" }
const _hoisted_83 = { class: "inputGroup" }
const _hoisted_84 = { class: "groupTitle" }
const _hoisted_85 = {
  key: 0,
  class: "groupInputs flex"
}
const _hoisted_86 = { class: "inputRow" }
const _hoisted_87 = { class: "inputField flex my-2" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "inputTitle ml-2" }
const _hoisted_90 = { for: "couplingEnabled" }
const _hoisted_91 = { class: "groupInputs flex" }
const _hoisted_92 = { class: "inputRow" }
const _hoisted_93 = { class: "inputTitle" }
const _hoisted_94 = { class: "inputField flex-grow" }
const _hoisted_95 = { class: "inputRow" }
const _hoisted_96 = { class: "inputTitle" }
const _hoisted_97 = { class: "inputField flex-grow" }
const _hoisted_98 = { class: "groupInputs flex" }
const _hoisted_99 = { class: "inputRow" }
const _hoisted_100 = { class: "inputTitle" }
const _hoisted_101 = { class: "inputField flex-grow" }
const _hoisted_102 = { class: "error-msg" }
const _hoisted_103 = { class: "inputRow" }
const _hoisted_104 = { class: "inputTitle" }
const _hoisted_105 = { class: "inputField flex-grow" }
const _hoisted_106 = { class: "groupInputs flex" }
const _hoisted_107 = {
  key: 0,
  class: "inputRow"
}
const _hoisted_108 = { class: "inputTitle" }
const _hoisted_109 = { class: "inputField flex-grow" }
const _hoisted_110 = { class: "inputRow" }
const _hoisted_111 = { class: "inputTitle" }
const _hoisted_112 = { class: "inputField flex-grow" }
const _hoisted_113 = { class: "block w-full mt-4" }
const _hoisted_114 = { class: "mb-4" }
const _hoisted_115 = { class: "tooltip infoIcon" }
const _hoisted_116 = { class: "infoText tooltiptext shadow" }
const _hoisted_117 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_118 = { class: "inputTitle" }
const _hoisted_119 = { class: "inputField flex-grow" }
const _hoisted_120 = { class: "error-msg" }
const _hoisted_121 = ["disabled"]

import Text from "@/components/inputs/Text";
import {computed, onMounted, ref, toRef, watchEffect} from "vue";
import Select from "@/components/inputs/Select";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {DisdiStateType, ErrorLocationType} from "@/utilities/enums/Enums";
import Tags from "@/components/inputs/Tags";
import {helpers, required, email, between, maxLength, minLength, numeric} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import {Group1Service} from "@/utilities/services/entities/Group1Service";
import {Group2Service} from "@/utilities/services/entities/Group2Service";
import {SafetyInstructionService} from "@/utilities/services/entities/SafetyInstructionService";
import {ControlCenterService} from "@/utilities/services/entities/ControlCenterService";
import {MiscService} from "@/utilities/services/entities/MiscService";
import TextOrSpinner from "@/components/TextOrSpinner";
import {$t} from "@/utilities/i18n/config";
import {ActivitySetService} from "@/utilities/services/entities/ActivitySetService";
import {phoneNumberPlaceholder} from "@/AppConfig";



export default /*@__PURE__*/_defineComponent({
  __name: 'LocationInfoEditor',
  props: {
  data: Object
},
  setup(__props) {

const { t } = useI18n();
const group1Service = new Group1Service();
const group2Service = new Group2Service();
const safetyInstructionService = new SafetyInstructionService();
const controlCenterService = new ControlCenterService();
const miscService = new MiscService();
const activitySetService = new ActivitySetService();

const props = __props

const globalStore = useGlobalStore();
const popupData = toRef(props, 'data');
const callNumber = ref("");

const regionList = ref(null);
const levelList = ref(null);
const controlCenterList = ref(null);
const safetyInstructionList = ref(null);
const pdfTemplateList = ref(null);
const activitySetList = ref(null);
const disdiIsOn = ref<boolean>(false);
const disdiForAll = ref<boolean>(false);

const loading = ref<boolean>(false);

// Computed Property für postalCode
const postalCode = computed({
  get() {
    return popupData.value && popupData.value.contactInfo
      ? popupData.value.contactInfo.postalCode
      : '';
  },
  set(newValue) {
    if (popupData.value && popupData.value.contactInfo) {
      popupData.value.contactInfo.postalCode = newValue;
    }
  }
});

const voiceTestCall = async () => {
  loading.value = true;

  const isValid = await testCallValidator.value.$validate();

  if(!isValid) {
    loading.value = false;

    const targetElement = document.querySelector(".error");
    targetElement.scrollIntoView({behavior: "smooth", block: 'center'});

    return;
  }

  // check if there is a name pronunciation
  let nameToRead = "";
  if(popupData.value.namePronunciation === "") {
    nameToRead = popupData.value.name;
  } else {
    nameToRead = popupData.value.namePronunciation;
  }

  // sadly can't get generalResponse here so it is fire and forget
  await miscService.postVoiceTestCall(nameToRead, callNumber.value);

  loading.value = false;
};

const setActivitySetId = (id) => {
  popupData.value.activitySetId = id;
}

const setPdfTemplate = (id) => {
  popupData.value.pdfTemplate = id;
}

const selectionChanged = (selectedList)=>{
  popupData.value.safetyInstructions = selectedList;
}

watchEffect(() => {
  if (popupData.value.controlCenterId !== undefined && popupData.value.controlCenterId !== null && controlCenterList.value !== null)
    popupData.value.controlCenterName = controlCenterList.value.find(cc => cc.id === popupData.value.controlCenterId)?.name;

  return popupData.value.controlCenterId
});

watchEffect(() => {
  if (popupData.value.group1Id !== null && regionList.value !== null)
    popupData.value.group1Name = regionList.value.find(g1 => g1.id === popupData.value.group1Id)?.name;

  return popupData.value.group1Id
});

watchEffect(() => {
  if (popupData.value.group2Id !== null && levelList.value !== null)
    popupData.value.group2Name = levelList.value.find(g2 => g2.id === popupData.value.group2Id)?.name;

  return popupData.value.group2Id
});

onMounted(async ()=>{
  disdiIsOn.value = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;
  disdiForAll.value = globalStore.settings.disdiSettings?.disdi === DisdiStateType.AllLocations;

  const regionResp = await group1Service.getRegions();
  if(regionResp === null || regionResp === undefined || regionResp.statusCode !== 0){
    ErrorHandler.handleError(regionResp, ErrorLocationType.popup);
    return;
  }
  regionList.value = regionResp.regionInfo;

  const levelResp = await group2Service.getLevels();
  if(levelResp === null || levelResp === undefined || levelResp.statusCode !== 0) {
    ErrorHandler.handleError(levelResp, ErrorLocationType.popup);
    return;
  }
  levelList.value = levelResp.levelInfo;

  const controlCenterResp = await controlCenterService.getControlCenters()
  if(controlCenterResp === null || controlCenterResp === undefined || controlCenterResp.statusCode !== 0){
    ErrorHandler.handleError(controlCenterResp, ErrorLocationType.popup);
    return;
  }
  controlCenterList.value = controlCenterResp.controlCenterInfo;

  const safetyInstructionResp = await safetyInstructionService.getSafetyInstructions();
  if(safetyInstructionResp === null || safetyInstructionResp === undefined || safetyInstructionResp.statusCode !== 0){
    ErrorHandler.handleError(safetyInstructionResp, ErrorLocationType.popup);
    return;
  }
  safetyInstructionList.value = safetyInstructionResp.safetyInstructionInfo;

  const templateResp = await miscService.getPdfTemplates();
  if(templateResp === null || templateResp === undefined || templateResp.statusCode !== 0){
    ErrorHandler.handleError(templateResp, ErrorLocationType.popup);
    return;
  }
  pdfTemplateList.value = templateResp.selectablePDFTemplate;

  // convert si list on popupData
  const convertedArray = [];
  for (const item of popupData.value.safetyInstructions){
    const fullInstruction = safetyInstructionList.value.find(si => si.id === item);

    const convertedItem = {
      id:item,
      name: fullInstruction.name
    };
    convertedArray.push(convertedItem);

    safetyInstructionList.value = safetyInstructionList.value.filter(si => si.id !== item);
  }
  popupData.value.safetyInstructions = convertedArray;

  const activitySetResp = await activitySetService.getActivitySets();
  if(activitySetResp === null || activitySetResp === undefined || activitySetResp.statusCode !== 0){
    ErrorHandler.handleError(activitySetResp, ErrorLocationType.popup);
    return;
  }
  activitySetList.value = activitySetResp.activitySetInfo.map(as => {
    as.id = as.activitySetId;
    return as;
  });
});

// Validation
const phoneNumbersValidator = helpers.regex(/^\+[0-9]+$/);
const floatValidator = helpers.regex(/^\d*[.,]?\d+?$/);
const postalCodeValidator = helpers.regex(/^(?:\d{5}|\d{5}-\d{4}|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/);
const rules = computed(() => {
  const rules = {
    registrationRadius:{
      floatValidator: helpers.withMessage(
          t('validators.float'),
          floatValidator
      ),
    },
    secondaryId: {
      required: helpers.withMessage(t('validators.required'), required),
      numeric: helpers.withMessage(t('validators.numeric'), numeric),
      maxLength: helpers.withMessage(t('validators.maxLength', {amount: 5}), maxLength(5)),
      minLength: helpers.withMessage(t('validators.minLength', {amount: 5}), minLength(5))
    },
    name: { required: helpers.withMessage(t('validators.required'), required) },
    email: {
      required: helpers.withMessage(t('validators.required'), required),
      email: helpers.withMessage(t('validators.email'), email)
    },
    controlCenterId: { required: helpers.withMessage(t('validators.required'), required) },
    longitude: {
      between: helpers.withMessage(t('validators.longitude'), between(-180, 180)),
    },
    latitude: {
      between: helpers.withMessage(t('validators.latitude'), between(-90, 90)),
    },
    contactInfo: {
      phoneNumber:{
        phoneNumbersValidator: helpers.withMessage(
            t('validators.phoneNumber'),
            phoneNumbersValidator
        ),
      },
      phoneNumberAlt1: {
        phoneNumbersValidator: helpers.withMessage(
            t('validators.phoneNumber'),
            phoneNumbersValidator
        ),
      },
      phoneNumberAlt2: {
        phoneNumbersValidator: helpers.withMessage(
            t('validators.phoneNumber'),
            phoneNumbersValidator
        ),
      },
      postalCode: {
        postalCodeValidator: helpers.withMessage(
            t('validators.postalCode'),
            postalCodeValidator
        )
      }
    },
  }
  return rules
})
const v$ = ref(useVuelidate(rules, popupData))



const readerRules = computed(()=>{
  return {
    numberToCall: {
      phoneNumbersValidator: helpers.withMessage(
          $t('validators.phoneNumber'),
          phoneNumbersValidator
      ),
      required: helpers.withMessage(
          $t('validators.required'),
          required
      )
    },
  }
})
const callData = computed(()=>{
  return {numberToCall: callNumber.value}
})
const testCallValidator = ref(useVuelidate(readerRules, callData));
const hideCallValidatorErrors = ()=>{
  testCallValidator.value.$reset();
}

onMounted(() => {
  globalStore.modal.validator = v$;
})


return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)('popups.locationInfo.section1')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('popups.locationInfo.secondaryId')) + " * ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.secondaryId.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.secondaryId) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.secondaryId]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.secondaryId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref($t)('popups.locationInfo.syncId')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.syncId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.syncId) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref($t)('popups.locationInfo.latitude')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.latitude.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((popupData.value.latitude) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.latitude]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.latitude.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref($t)('popups.locationInfo.longitude')), 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.longitude.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popupData.value.longitude) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.longitude]
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.longitude.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref($t)('popups.locationInfo.registrationRadius')), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.registrationRadius.$errors.length })
            }, [
              _createVNode(_unref(Text), {
                modelValue: popupData.value.registrationRadius,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((popupData.value.registrationRadius) = $event))
              }, null, 8, ["modelValue"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.registrationRadius.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref($t)('popups.locationInfo.section2')), 1),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref($t)('popups.locationInfo.name')) + " * ", 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.name.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((popupData.value.name) = $event)),
                ref: "name",
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.name]
              ]),
              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('popups.locationInfo.namePronunciation')), 1),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.namePronunciation,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((popupData.value.namePronunciation) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref($t)('popups.locationInfo.street')), 1),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.contactInfo.street,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((popupData.value.contactInfo.street) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, _toDisplayString(_unref($t)('popups.locationInfo.streetNumber')), 1),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.contactInfo.streetNumber,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((popupData.value.contactInfo.streetNumber) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, _toDisplayString(_unref($t)('popups.locationInfo.postalCode')), 1),
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_unref(Text), {
              modelValue: postalCode.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((postalCode).value = $event)),
              modelModifiers: { number: true },
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, _toDisplayString(_unref($t)('popups.locationInfo.city')), 1),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.contactInfo.city,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((popupData.value.contactInfo.city) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, _toDisplayString(_unref($t)('popups.locationInfo.email')) + " * ", 1),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.email.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((popupData.value.email) = $event)),
                class: "w-full"
              }, null, 512), [
                [_vModelText, popupData.value.email]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.email.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_52, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumber')), 1),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.contactInfo.phoneNumber.$errors.length })
            }, [
              _createVNode(_unref(Text), {
                modelValue: popupData.value.contactInfo.phoneNumber,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((popupData.value.contactInfo.phoneNumber) = $event)),
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, ["modelValue", "placeholder"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.contactInfo.phoneNumber.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_56, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, _toDisplayString(_unref($t)('popups.locationInfo.section3')), 1),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((popupData.value.phoneNumberAltIsFallback) = $event)),
              name: "phoneNumberAltIsFallback"
            }, null, 512), [
              [_vModelCheckbox, popupData.value.phoneNumberAltIsFallback]
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", _hoisted_63, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAltIsFallback')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((popupData.value.couplingEnabled) = $event)),
              name: "couplingEnabled"
            }, null, 512), [
              [_vModelCheckbox, popupData.value.couplingEnabled]
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("label", _hoisted_67, _toDisplayString(_unref($t)('popups.locationInfo.couplingEnabled')), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAlt1')), 1),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.contactInfo.phoneNumberAlt1.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((popupData.value.phoneNumberAlt1) = $event)),
                class: "w-full",
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, _hoisted_72), [
                [_vModelText, popupData.value.phoneNumberAlt1]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.contactInfo.phoneNumberAlt1.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_73, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, _toDisplayString(_unref($t)('popups.locationInfo.phoneNumberAlt2')), 1),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.contactInfo.phoneNumberAlt2.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((popupData.value.phoneNumberAlt2) = $event)),
                class: "w-full",
                placeholder: _unref(phoneNumberPlaceholder)
              }, null, 8, _hoisted_77), [
                [_vModelText, popupData.value.phoneNumberAlt2]
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.contactInfo.phoneNumberAlt2.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_78, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, _toDisplayString(_unref($t)('popups.locationInfo.customAdditionalInformation')), 1),
          _createElementVNode("div", _hoisted_82, [
            _createVNode(_unref(Text), {
              modelValue: popupData.value.customAdditionalInformation,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((popupData.value.customAdditionalInformation) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, _toDisplayString(_unref($t)('popups.locationInfo.section4')), 1),
      (disdiIsOn.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((popupData.value.hasDisdi) = $event)),
                  disabled: disdiForAll.value,
                  name: "hasDisdi"
                }, null, 8, _hoisted_88), [
                  [_vModelCheckbox, popupData.value.hasDisdi]
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("label", _hoisted_90, _toDisplayString(_unref($t)('popups.locationInfo.hasDisdi')), 1)
                ])
              ])
            ])
          ])), [
            [_directive_permission, 'Disdi.LocationPropertyEdit']
          ])
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, _toDisplayString(_unref($t)('popups.locationInfo.group1AndName')), 1),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_unref(Select), {
              selected: popupData.value.group1Id,
              options: regionList.value,
              mode: "single",
              onSelectChanged: _cache[19] || (_cache[19] = (value)=>{popupData.value.group1Id = value})
            }, null, 8, ["selected", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, _toDisplayString(_unref($t)('popups.locationInfo.group2IdAndName')), 1),
          _createElementVNode("div", _hoisted_97, [
            _createVNode(_unref(Select), {
              selected: popupData.value.group2Id,
              options: levelList.value,
              mode: "single",
              onSelectChanged: _cache[20] || (_cache[20] = (value)=>{popupData.value.group2Id = value})
            }, null, 8, ["selected", "options"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, _toDisplayString(_unref($t)('popups.locationInfo.controlCenterIdAndName')) + " * ", 1),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.controlCenterId.$errors.length })
            }, [
              _createVNode(_unref(Select), {
                selected: popupData.value.controlCenterId,
                options: controlCenterList.value,
                mode: "single",
                onSelectChanged: _cache[21] || (_cache[21] = (value)=>{popupData.value.controlCenterId = value})
              }, null, 8, ["selected", "options"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.controlCenterId.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_102, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_103, [
          _createElementVNode("div", _hoisted_104, _toDisplayString(_unref($t)('popups.locationInfo.safetyInstructions')), 1),
          _createElementVNode("div", _hoisted_105, [
            _createVNode(_unref(Tags), {
              options: safetyInstructionList.value,
              selected: popupData.value.safetyInstructions,
              onSelectChanged: selectionChanged
            }, null, 8, ["options", "selected"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_106, [
        (_unref(globalStore).settings.activitySettings.activitesEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, _toDisplayString(_unref($t)('popups.locationInfo.activitySet')), 1),
              _createElementVNode("div", _hoisted_109, [
                _createVNode(_unref(Select), {
                  selected: popupData.value.activitySetId,
                  options: activitySetList.value,
                  mode: "single",
                  onSelectChanged: setActivitySetId
                }, null, 8, ["selected", "options"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("div", _hoisted_111, _toDisplayString(_unref($t)('popups.locationInfo.pdfTemplate')), 1),
          _createElementVNode("div", _hoisted_112, [
            _createVNode(_unref(Select), {
              selected: popupData.value.pdfTemplate,
              options: pdfTemplateList.value,
              mode: "single",
              onSelectChanged: setPdfTemplate
            }, null, 8, ["selected", "options"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_113, [
        _createElementVNode("h3", _hoisted_114, [
          _createTextVNode(_toDisplayString(_unref($t)('popups.locationInfo.readerTitle')) + " ", 1),
          _createElementVNode("span", _hoisted_115, [
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "icon-info" }, null, -1)),
            _createElementVNode("span", _hoisted_116, _toDisplayString(_unref($t)('popups.locationInfo.readerTooltip')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_118, _toDisplayString(_unref($t)('popups.locationInfo.readerPhonenumber')), 1),
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", {
                class: _normalizeClass({ error: testCallValidator.value.numberToCall.$errors.length })
              }, [
                _createVNode(_unref(Text), {
                  modelValue: callNumber.value,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((callNumber).value = $event)),
                  onFocusout: hideCallValidatorErrors,
                  placeholder: _unref(phoneNumberPlaceholder)
                }, null, 8, ["modelValue", "placeholder"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testCallValidator.value.numberToCall.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "input-errors",
                    key: error.$uid
                  }, [
                    _createElementVNode("div", _hoisted_120, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ], 2),
              _createElementVNode("button", {
                class: "primary mt-2",
                onClick: voiceTestCall,
                disabled: loading.value
              }, [
                _createVNode(_unref(TextOrSpinner), {
                  text: _unref($t)('popups.reader.button'),
                  spin: loading.value
                }, null, 8, ["text", "spin"])
              ], 8, _hoisted_121)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})